<template>
<div style="margin-top: 113px">
  <v-container>
    <v-card>
      <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="snackBarTimeout">
        <b>{{ snackBarText }} </b>
      </v-snackbar>
      <v-card-title>
        Change my password
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="changePassword.currentPassword" type="password" label="Current password"></v-text-field>
          <v-text-field v-model="changePassword.newPassword" type="password" label="New password"></v-text-field>
          <v-text-field v-model="changePassword.confirmedNewPassword" type="password" label="Confirm new password"></v-text-field>
          <v-btn color="success" class="mr-4" @click="validate">
            Validate
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</div>
</template>

<script>
export default {
  name: 'Profile',
  data() {
    return {
      // [START] Data for autocomplete search
      changePassword: {
        currentPassword: '',
        newPassword: '',
        confirmedNewPassword: ''
      },
      snackbar: false,
      snackBarText: '',
      snackBarColor: '',
      snackBarTimeout: 2000
    }
  },
  methods: {
    validate: function () {
      if (this.changePassword.newPassword != this.changePassword.confirmedNewPassword) {
        this.snackBarColor = 'red';
        this.snackBarText = 'the new password is not equals to the confirmation';
        this.snackbar = true;
      } else {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/users/password", {
          method: 'PUT',
          credentials: 'include',
          headers: myHeaders,
          body: JSON.stringify(this.changePassword),

        }).then((response) => {
          this.changePassword = {
            currentPassword: '',
            newPassword: '',
            confirmedNewPassword: ''
          };
          return response.json();
        }).then((json) => {
          this.snackbar = true;
          if (json.status >= 200 && json.status < 300) {
            this.snackBarText = 'Saved successfully';
            this.snackBarColor = 'success'
          } else {
            this.snackBarText = 'Something went wrong : ' + json.message;
            this.snackBarColor = 'error'
          }
        })
      }
    },

  },
}
</script>
